import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Record } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
class UICustomDataWellHeader extends Component {
  static withProps(injected = {}) {
    return metric => /*#__PURE__*/_jsx(UICustomDataWellHeader, Object.assign({}, injected, {
      metric: metric
    }));
  }
  render() {
    const {
      metric
    } = this.props;
    return /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `knowledgeContentUI.insights.articleDetails.customLabels.${metric.get('property')}`
      })
    });
  }
}
UICustomDataWellHeader.propTypes = {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Record' is not assignable... Remove this comment to see the full error message
  metric: PropTypes.instanceOf(Record).isRequired
};
export default UICustomDataWellHeader;